<div class="modal fade" id="modal-ia-config" tabindex="-1">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Configure Internal Assessment - {{subjectName}}</h5>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <!-- Loading -->
                <div *ngIf="loading" class="text-center p-4">
                    <i class="fa fa-spinner fa-spin fa-2x"></i>
                    <p>Loading configuration...</p>
                </div>

                <!-- Existing Components -->
                <div *ngIf="!loading">
                    <h6>Configured Components</h6>
                    <table class="table table-bordered table-sm">
                        <thead>
                            <tr>
                                <th>Component Name</th>
                                <th>Type</th>
                                <th>Base Marks</th>
                                <th>Scaled Marks</th>
                                <th>Attempts</th>
                                <th>Best Of</th>
                                <th>Entry Type</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let comp of components; let i = index">
                                <td>{{comp.component_name}}</td>
                                <td>{{comp.component_type}}</td>
                                <td>{{comp.base_marks}}</td>
                                <td>{{comp.scaled_marks}}</td>
                                <td>{{comp.number_of_attempts}}</td>
                                <td>{{comp.best_of_attempts}}</td>
                                <td>
                                    <span class="badge" [ngClass]="comp.is_auto_calculated ? 'badge-success' : 'badge-warning'">
                                        {{comp.is_auto_calculated ? 'Auto' : 'Manual'}}
                                    </span>
                                </td>
                                <td>
                                    <button class="btn btn-xs btn-primary mr-1" (click)="editComponent(i)">
                                        <i class="fa fa-edit"></i>
                                    </button>
                                    <button class="btn btn-xs btn-danger" (click)="deleteComponent(comp.id)">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </td>
                            </tr>
                            <tr *ngIf="components.length == 0">
                                <td colspan="8" class="text-center text-muted">No components configured yet</td>
                            </tr>
                        </tbody>
                    </table>

                    <hr>

                    <!-- Add/Edit Component Form -->
                    <h6>{{editingIndex >= 0 ? 'Edit' : 'Add New'}} Component</h6>
                    <form>
                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Component Name <span class="text-danger">*</span></label>
                                    <input type="text" class="form-control form-control-sm" [(ngModel)]="newComponent.component_name" name="component_name" placeholder="e.g., Theory, IA, Viva">
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label>Type</label>
                                    <select class="form-control form-control-sm" [(ngModel)]="newComponent.component_type" name="component_type">
                                        <option *ngFor="let type of componentTypes" [value]="type.value">{{type.label}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label>Base Marks</label>
                                    <input type="number" class="form-control form-control-sm" [(ngModel)]="newComponent.base_marks" name="base_marks" step="0.01">
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label>Scaled Marks</label>
                                    <input type="number" class="form-control form-control-sm" [(ngModel)]="newComponent.scaled_marks" name="scaled_marks" step="0.01">
                                </div>
                            </div>
                            <div class="col-md-1">
                                <div class="form-group">
                                    <label>Attempts</label>
                                    <input type="number" class="form-control form-control-sm" [(ngModel)]="newComponent.number_of_attempts" name="number_of_attempts" min="1">
                                </div>
                            </div>
                            <div class="col-md-1">
                                <div class="form-group">
                                    <label>Best Of</label>
                                    <input type="number" class="form-control form-control-sm" [(ngModel)]="newComponent.best_of_attempts" name="best_of_attempts" min="1">
                                </div>
                            </div>
                            <div class="col-md-1">
                                <div class="form-group">
                                    <label>Entry</label>
                                    <select class="form-control form-control-sm" [(ngModel)]="newComponent.is_auto_calculated" name="is_auto_calculated">
                                        <option [value]="1">Auto</option>
                                        <option [value]="0">Manual</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <button type="button" class="btn btn-primary btn-sm" *ngIf="editingIndex < 0" (click)="addComponent()">
                                    <i class="fa fa-plus"></i> Add Component
                                </button>
                                <button type="button" class="btn btn-success btn-sm" *ngIf="editingIndex >= 0" (click)="updateComponent()">
                                    <i class="fa fa-save"></i> Update Component
                                </button>
                                <button type="button" class="btn btn-secondary btn-sm ml-2" *ngIf="editingIndex >= 0" (click)="cancelEdit()">
                                    <i class="fa fa-times"></i> Cancel
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>
